export const evaluationReducer = (state = { loading: false, evaluations: [], evaluationError: null }, action) => {
    switch (action.type) {
        case 'EVALUATIONS_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'EVALUATIONS_SUCCESS':
            return {
                ...state,
                loading: false,
                evaluations: action.payload
            }
        case 'EVALUATIONS_ERROR':
            return {
                ...state,
                loading: false,
                evaluationError: action.payload
            }
        case 'EVALUATION_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                evaluations: [...state.evaluations, action.payload]
            }
        default:
            return state
    }
}
